import React from 'react';
import Settings from '../../../Settings/Settings'
import Style from '../Styles/CreateAccountPaperStyle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';
import AddFirm from '../../Firms/Firms';
import {
    Link
  } from "react-router-dom";

export default function CreateAccountPaper(props) {
    const classes = Style();

    const componentConstants = {
        ...props.componentConstants
    }

    const componentMethods = {
        ...props.componentMethods
    }

    const [createAccountUsersFirstName, setCreateAccountUsersFirstName] = React.useState("")
    const [createAccountUsersLastName, setCreateAccountUsersLastName] = React.useState("")
    const [createAccountUsersEmail, setCreateAccountUsersEmail] = React.useState("")
    const [createAccountUsersPassword, setCreateAccountUsersPassword] = React.useState("")
    const [createAccountUsersPasswordConfirm,setCreateAccountUsersPasswordConfirm] = React.useState("")
    const [createAccountUsersDateOfBirthYear,setCreateAccountUsersDateOfBirthYear] = React.useState("")
    const [createAccountUsersDateOfBirthMonth, setCreateAccountUsersDateOfBirthMonth] = React.useState("")
    const [createAccountUsersDateOfBirthDay, setCreateAccountUsersDateOfBirthDay] = React.useState("")
    const [createAccountUsersSexID, setCreateAccountUsersSexID] = React.useState("")
    const [agreeTermsAndConditions, setAgreeTermsAndConditions] = React.useState(false)

    const handleChangeAgreeTermsAndConditions = (event) => {
        setAgreeTermsAndConditions(event.target.checked);
    };

    const createAccountAction = () => {
        if(!agreeTermsAndConditions) {
            componentMethods.addError(componentMethods.getManagerState().language["LANG_ERROR_TERMS_AND_CONDITIONS"])
            return
        }
        componentMethods.setManagerState({loadingCreateAccount: true})
        if(createAccountUsersPassword !== createAccountUsersPasswordConfirm) {
            componentMethods.addError(componentMethods.getManagerState().language["LANG_ERROR_INVALID_PASSWORD_CONFIRM"], {formInvalidCreateAccountPassword: true, formInvalidCreateAccountPasswordConfirm: true, loadingCreateAccount: false})
        } else {
            let requestCreateAccountObject = {
            }
            if (createAccountUsersEmail) {
                requestCreateAccountObject.usersEmail = createAccountUsersEmail
            }
            if (createAccountUsersPassword) {
                requestCreateAccountObject.usersPassword = createAccountUsersPassword
            }
            if (createAccountUsersDateOfBirthYear && createAccountUsersDateOfBirthMonth && createAccountUsersDateOfBirthDay) {
                requestCreateAccountObject.usersDateOfBirth = createAccountUsersDateOfBirthYear + '-' + createAccountUsersDateOfBirthMonth + '-' + createAccountUsersDateOfBirthDay
            }
            if (createAccountUsersSexID) {
                requestCreateAccountObject.usersUsersSexID = createAccountUsersSexID
            }
            if (createAccountUsersFirstName) {
                requestCreateAccountObject.usersFirstName = createAccountUsersFirstName
            }
            if (createAccountUsersLastName) {
                requestCreateAccountObject.usersLastName = createAccountUsersLastName
            }    
            componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_REGISTER,requestCreateAccountObject,'POST',null, (data) => {componentMethods.setSuccessfulUsersRegister(data)}, {}, false, (data) => {
                componentMethods.setCreateAccountErrors(data)
                componentMethods.setManagerState({loadingCreateAccount: false})
            })
        }

    }

    if(componentMethods.getManagerState().successfulUsersRegister) {
        return (
            <div className={classes.root}>
                <Typography variant="h5" component="h5" style={classes.title}>
                {componentConstants.language.LANG_SUCCESSFUL_REGISTER}
                </Typography>
                <Button onClick={() => {
                    componentMethods.setManagerState({successfulUsersRegister: false})
                    componentMethods.clearCreateAccountForm()
                    }} variant="contained" disableElevation color="secondary" fullWidth={true} style={classes.closeButton}>
                    {componentConstants.language.LANG_BACK}
                </Button>
                <Button onClick={componentMethods.handleClosePopover} variant="outlined" color="secondary" fullWidth={true} style={classes.closeButton}>
                    {componentConstants.language.LANG_CLOSE}
                </Button>
            </div>
            )
    }
  return (
    <form style={classes.root} noValidate autoComplete="off">
        <Typography variant="h5" component="h5" style={classes.title}>
            {componentConstants.language.LANG_CREATE_ACCOUNT}
        </Typography>
        <TextField value={createAccountUsersFirstName} error={componentMethods.getManagerState().formInvalidCreateAccountUsersFirstName} style={classes.formFullWidth} onChange={(event) => {setCreateAccountUsersFirstName(event.target.value)}} id="CREATE_ACCOUNT_FIRST_NAME" label={componentConstants.language.LANG_FIRST_NAME} fullWidth={true} />
        <TextField value={createAccountUsersLastName} error={componentMethods.getManagerState().formInvalidCreateAccountUsersLastName} style={classes.formFullWidth} onChange={(event) => {setCreateAccountUsersLastName(event.target.value)}} id="CREATE_ACCOUNT_LAST_NAME" label={componentConstants.language.LANG_LAST_NAME} fullWidth={true} />
        <TextField value={createAccountUsersEmail} error={componentMethods.getManagerState().formInvalidCreateAccountUsersEmail} style={classes.formFullWidth} onChange={(event) => {setCreateAccountUsersEmail(event.target.value)}} id="CREATE_ACCOUNT_EMAIL" label={componentConstants.language.LANG_EMAIL} fullWidth={true} />
        <TextField value={createAccountUsersPassword} type="password" error={componentMethods.getManagerState().formInvalidCreateAccountPassword} style={classes.formFullWidth} onChange={(event) => {setCreateAccountUsersPassword(event.target.value)}} id="CREATE_ACCOUNT_PASSWORD" label={componentConstants.language.LANG_PASSWORD} fullWidth={true} />
        <TextField value={createAccountUsersPasswordConfirm} type="password" error={componentMethods.getManagerState().formInvalidCreateAccountPasswordConfirm} style={classes.formFullWidth} onChange={(event) => {setCreateAccountUsersPasswordConfirm(event.target.value)}} id="CREATE_ACCOUNT_CONFIRM_PASSWORD" label={componentConstants.language.LANG_CONFIRM_PASSWORD} fullWidth={true} />
        <FormControl style={classes.formControlSelect}>
            <InputLabel id="CREATE_ACCOUNT_BIRTH_DAY_INPUT_LABEL">{componentConstants.language.LANG_DATE_OF_BIRTH_DAY}</InputLabel>
            <Select
             error={componentMethods.getManagerState().formInvalidCreateAccountUsersDateOfBirth}
            value={createAccountUsersDateOfBirthDay}
             onChange={(event) => {setCreateAccountUsersDateOfBirthDay(event.target.value)}}
            labelId="CREATE_ACCOUNT_BIRTH_DAY_LABEL"
            id="CREATE_ACCOUNT_BIRTH_DAY"
            >
           {['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'].map((element, index) => { 
                return <MenuItem key={index} value={element}>{element}</MenuItem>
            })}
            </Select>
        <FormHelperText>{componentConstants.language.LANG_DATE_OF_BIRTH}</FormHelperText>
      </FormControl>
      <FormControl style={classes.formControlSelect}>
            <InputLabel id="CREATE_ACCOUNT_BIRTH_MONTH_INPUT_LABEL">{componentConstants.language.LANG_DATE_OF_BIRTH_MONTH}</InputLabel>
            <Select
            error={componentMethods.getManagerState().formInvalidCreateAccountUsersDateOfBirth}
            value={createAccountUsersDateOfBirthMonth}
            onChange={(event) => {setCreateAccountUsersDateOfBirthMonth(event.target.value)}}
            labelId="CREATE_ACCOUNT_BIRTH_MONTH_LABEL"
            id="CREATE_ACCOUNT_BIRTH_MONTH_LABEL"
            >
            {['01','02','03','04','05','06','07','08','09','10','11','12'].map((element, index) => { 
                return <MenuItem key={index} value={element}>{element}</MenuItem>
            })}
            </Select>
        <FormHelperText>{componentConstants.language.LANG_DATE_OF_BIRTH}</FormHelperText>
      </FormControl>
      <FormControl style={classes.formControlSelect}>
            <InputLabel id="CREATE_ACCOUNT_BIRTH_YEAR_INPUT_LABEL">{componentConstants.language.LANG_DATE_OF_BIRTH_YEAR}</InputLabel>
            <Select
            error={componentMethods.getManagerState().formInvalidCreateAccountUsersDateOfBirth}
            value={createAccountUsersDateOfBirthYear}
            labelId="CREATE_ACCOUNT_BIRTH_YEAR_LABEL"
            id="CREATE_ACCOUNT_BIRTH_YEAR"
            onChange={(event) => {setCreateAccountUsersDateOfBirthYear(event.target.value)}}
            >
                {componentMethods.getManagerState().createAccountYears.items.map((element, index) => { 
                        return <MenuItem key={index} value={element.year}>{element.year}</MenuItem>
                     })}
            </Select>
        <FormHelperText>{componentConstants.language.LANG_DATE_OF_BIRTH}</FormHelperText>
      </FormControl>
      <FormControl  error={componentMethods.getManagerState().formInvalidCreateAccountUsersUsersSexID} component="fieldset" style={classes.formFullWidth}>
        <FormLabel  style={classes.formFullWidth} component="legend">{componentConstants.language.LANG_SEX}</FormLabel>
            <RadioGroup aria-label="gender" name="usersUsersSexID"  style={classes.formRadioGroup} value={createAccountUsersSexID} onChange={(event) => {setCreateAccountUsersSexID(event.target.value)}} >
                <FormControlLabel style={classes.formControlRadioGroup} value={"2"} control={<Radio />} label={componentConstants.language.LANG_FEMALE} />
                <FormControlLabel style={classes.formControlRadioGroup} value={"1"} control={<Radio />} label={componentConstants.language.LANG_MALE} />
                <FormControlLabel style={classes.formControlRadioGroup} value={"3"} control={<Radio />} label={componentConstants.language.LANG_OTHER} />
            </RadioGroup>
        </FormControl> 
         <FormControlLabel style={classes.formFullWidth}
        control={<Checkbox value={1} checked={agreeTermsAndConditions} onChange={handleChangeAgreeTermsAndConditions} />}
        label={<React.Fragment>{componentConstants.language["LANG_AGREE_TERMS_AND_CONDITIONS"]} <Link style={classes.termsAndConditionsLink} to="/termeni-si-conditii">{componentConstants.language.LANG_AGREE_TERMS_AND_CONDITIONS_NAME}</Link></React.Fragment> }
      />
        {componentMethods.getManagerState().loadingCreateAccount ?
        <CircularProgress />
        :
        <Button onClick={createAccountAction} variant="contained" disableElevation color="secondary" fullWidth={true} style={classes.closeButton}>
            {componentConstants.language.LANG_CREATE_ACCOUNT}
        </Button>
        }
    </form>
  );
}